<mat-card class="content-card">
  <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </mat-card-header>
  <form [formGroup]="form" (submit)="validateRssUrl()" class="rss-form">
    <div class="input-wrapper">
      <mat-form-field appearance="outline">
        <mat-label>URL</mat-label>
        <input
          matInput
          type="text"
          formControlName="url"
          placeholder="https://example.com/rssfeed"
        />
      </mat-form-field>
    </div>
    <mat-form-field *ngIf="!forceModule" appearance="outline">
      <mat-label>Module</mat-label>
      <mat-select formControlName="module">
        <mat-option *ngFor="let module of validationModules" [value]="module">{{
          module
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="showRssTypeInput" appearance="outline">
      <mat-label>Rss Feed type</mat-label>
      <mat-select formControlName="newsRssFeedType">
        <mat-option *ngFor="let rssType of newsRssFeedTypes" [value]="rssType">{{
          rssType
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="validateRssUrl()">
      Validate
    </button>
  </form>

  <section class="results" *ngIf="!loading && submitted">
    <app-rss-validator-form-errors
      [results]="results"
    ></app-rss-validator-form-errors>
  </section>
</mat-card>
